import React from "react";
import { Card } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import './OpalAccordionCardV2.css';

const OpalAccordionCardV2 = ({
    item,
    selectedCard,
    setSelectedCard,
    search,
    onSelectItem
}) => {
    const highlightText = (text, query) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, "gi");
        return text.split(regex).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} className="highlighted-text">{part}</span>
            ) : (
                part
            )
        );
    };

    return (
        <Card key={item.ID} className="card-v2 mb-2">
            <div
                className={`custom-card card-body ${selectedCard === item.ID ? "active-card" : ""} p-3`}
                onClick={() => {
                    setSelectedCard(item.ID);
                }}
            >
                <TauriImage
                    localImage={"/Images/flat-color-icons--plus.svg"}
                    className={"add-icon"}
                    alt="icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedCard(item.ID);
                        onSelectItem?.(item);
                    }}
                />
                <Card.Title>
                    <span>{item?.type === 1 ? 'DR. ' : ''}</span>
                    {highlightText(item?.Customer?.Name?.toUpperCase(), search)}
                </Card.Title>
                <div className="details">
                    <span>{item?.Customer?.Frequency_code}</span>
                    <span> - </span>
                    {item?.Time_call}
                </div>
                <div className="description">
                    {highlightText(item?.institution, search)}
                </div>
                <div className="progress-details d-flex align-items-center">
                    <TauriImage
                        localImage={"/Images/solar--checklist-outline.svg"}
                        alt="icon"
                        color={"#000"}
                    />
                    <span>0/{item?.Customer?.Frequency_count}</span>
                </div>
            </div>
        </Card>
    );
};

export default OpalAccordionCardV2;
